const language = {
  namespaced: true,
  state: {
    appLanguage: localStorage.getItem('cat4mroLanguage') || 'en-US',
  },
  mutations: {
    setAppLanguage(state, choicedLanguage) {
      state.appLanguage = choicedLanguage;
      localStorage.setItem('cat4mroLanguage', choicedLanguage); // Whenever we change the appLanguage we save it to the localStorage
    },
  },
  getters: {
    getAppLanguage: state => state.appLanguage,
  },
};

export default language;



// WEBPACK FOOTER //
// ./src/store/modules/core/language.js